<template>
  <div class="home-menu--wrapper has-background-white-ter">
    <div class="home-menu--city " style="padding: 4px 16px 2px 16px">
      <h2 class="has-text-weight-bold is-size-4 has-text-black">{{ $store.state.user.userCity }}</h2>
    </div>

    <div class="home-menu--grid">
      <router-link :to="{name: 'events', params: {cityName: $route.params.cityName, slug:key}}" class="home-menu-item has-text-grey-dark" v-for="(val, key) of $store.state.ui.typeIcons" :key="key.id">
        <div class="is-block">
          <span class="icon">
            <i class="mdi mdi-24px" :class="$store.state.ui.typeIcons[key].typeIcon"></i>
          </span>
        </div>
        <p class="is-size-15px">{{ $t(`evType.${key}`) }}</p>
      </router-link>
      <div  class="home-menu-item has-text-grey-dark" v-if="false">
        <div class="is-block">
          <span class="icon">
            <i class="mdi mdi-24px mdi-dots-horizontal"></i>
          </span>
        </div>
        <p class="is-size-15px">{{ $t(`evType.more`) }}</p>
      </div>
    </div>
    <div  @click="$router.push({name: 'search'})" class="search-box mx-1" style="transform: translateY(20px); margin-top: -20px">
      <b-field >
            <b-input type="search"
                icon="magnify" :placeholder="$t('ui.searchPlaceholder')" expanded rounded></b-input>
            <!-- <p class="control">
                <span class="button is-static">@gmail.com</span>
            </p> -->
        </b-field>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.home-menu--grid {
    // padding-top: 12px;
    // padding-bottom: 8px;
    padding: 4px 12px;
  display: grid;
  grid-template-columns: repeat(3, 64px);
justify-content: space-between;
  grid-column-gap: 32px;
  grid-row-gap: 4px;
}

.home-menu-item {
    padding-top: 2px;
    padding-bottom: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;
}
</style>